import { NavLink } from "react-router-dom";
import { MessageCircle, Heart } from "lucide-react"; // ✅ icons for comments and likes

function BlogCard({ image, title, excerpt, category, to, commentsCount = 0, likesCount = 0 }) {
  return (
    <NavLink
      to={to}
      className="block bg-white rounded shadow overflow-hidden hover:shadow-lg transform transition duration-300 hover:scale-[1.02]"
      data-aos="zoom-in"
    >
      <div className="h-40 bg-gray-200 relative">
        <img src={image} alt={title} className="w-full h-full object-cover" />

        {/* Category Badge */}
        {category && (
          <span className="absolute top-2 left-2 bg-black/60 text-white text-xs px-3 py-1 rounded">
            {category}
          </span>
        )}
      </div>

      <div className="p-4">
        <h4 className="font-semibold text-lg">{title}</h4>
        <p className="text-sm text-gray-500 mt-2 line-clamp-2">{excerpt}</p>

        <div className="flex justify-between items-center mt-4 text-sm">
          <span className="text-blue-600 font-medium">Read More →</span>
          
          <div className="flex items-center gap-4 text-gray-500">
            <div className="flex items-center gap-1">
              <MessageCircle size={16} />
              <span>{commentsCount}</span>
            </div>
            <div className="flex items-center gap-1">
              <Heart size={16} />
              <span>{likesCount}</span>
            </div>
          </div>
        </div>
      </div>
    </NavLink>
  );
}

export default BlogCard;
